import { Svg, Circle, Text as SvgText } from '@react-pdf/renderer'
import { COLORS, RATINGS } from '../constants'

export function RatingCircle({ rating, size = 20 }) {
  const config = RATINGS[rating] || RATINGS['NI']
  const displayText = rating || 'NI'
  const isNI = rating === 'NI' || !rating

  const radius = size / 2 - 1
  const centerX = size / 2
  const centerY = size / 2
  const fontSize = isNI ? size * 0.4 : size * 0.5

  return (
    <Svg width={size} height={size}>
      {/* Circle background */}
      <Circle
        cx={centerX}
        cy={centerY}
        r={radius}
        fill={config.color}
        stroke={COLORS.black}
        strokeWidth={isNI ? 1.5 : 0}
      />
      {/* Rating text */}
      <SvgText
        x={centerX}
        y={centerY + fontSize * 0.35}
        fill={config.textColor}
        fontSize={fontSize}
        fontWeight="bold"
        textAnchor="middle"
      >
        {displayText}
      </SvgText>
    </Svg>
  )
}

export default RatingCircle
